import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";

import { FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import NumberFormat from "react-number-format";
import moment from 'moment';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import { AutocompleteContacts } from './AutocompleteContacts';
import { DialogProfileContact } from "../../contactos/DialogProfileContact";
import { Contacts } from "../../contactos/model";

export const DatosIniciales = ({ dataForm, handleChange, handleChangeCliente, handleChangeDate, handleChangeTipoDoc, handleChangeTipoCambio, handleChangeMoneda }) => {

    const { currencyList, listaFormasPagosVentas, listaTiposDocumentos, info } = useSelector(state => state.general)
    const { local_simbolo, local_separacion_miles, local_separacion_decimales } = info

    const { listCustomers } = useSelector(state => state.contacts)
    const [openProfileContact, setOpenProfileContact] = useState(false)

    const [infoCliente, setInfoCliente] = useState({
        razon_social: dataForm?.razon_social || 'sin info.',
        nro_documento: dataForm?.nro_documento || 'sin info.'
    })

    const setInfoClient = useCallback(() => {
        const clientFound = listCustomers?.find(c => parseInt(c.id) === parseInt(dataForm.id_cliente))
        if (clientFound) {
            setInfoCliente({
                razon_social: (listCustomers?.find(c => parseInt(c.id) === parseInt(dataForm.id_cliente)))?.razon_social || 'sin info.',
                nro_documento: (listCustomers?.find(c => parseInt(c.id) === parseInt(dataForm.id_cliente)))?.nro_documento || 'sin info.'
            })
        }
    }, [listCustomers, dataForm.id_cliente])

    const handleEditContact = async () => {
        let data = await Contacts.getOne(dataForm.id_cliente)

        if (data.tipo === '' || data.tipo === null) {
            data.tipo = 'empresa'
        }

        setInfoCliente(data)
        setOpenProfileContact(true)
    }

    useEffect(() => {
        setInfoClient()
    }, [dataForm.id_cliente, listCustomers, setInfoClient])

    return (
        <Grid>
            <Grid item xs={12}>
                <Grid container spacing='20' columnSpacing='16' rowSpacing='12' alignItems='center' direction='row'>

                    <Grid item xs={12} md={8} className="mt-1">
                        <TextField
                            label="Descripción factura"
                            name="referencia"
                            id="outlined-size-small"
                            value={dataForm.referencia || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese descripción de la factura'
                            onChange={handleChange}
                            disabled={dataForm.reading_mode}
                        />
                    </Grid>

                    <Grid item xs={12} md={4}></Grid>

                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                            <Select
                                label="Tipo de documento"
                                id="id_tipo_documento"
                                name="id_tipo_documento"
                                value={dataForm.id_tipo_documento || ''}
                                onChange={handleChangeTipoDoc}
                                className='p-list-capitalize'
                                disabled={dataForm.reading_mode}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaTiposDocumentos.map(item => (
                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <TextField
                            label="Número factura"
                            name="numero"
                            id="outlined-size-small"
                            value={dataForm.numero || ''}
                            size="small"
                            fullWidth
                            placeholder='F001-000123'
                            onChange={handleChange}
                            disabled={dataForm.reading_mode}
                        />
                    </Grid>

                    <Grid item xs={12} md={parseInt(dataForm.id_moneda) === 4 ? 2 : 3}>
                        <div className="p-text-date">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    label="Fecha factura"
                                    inputFormat="dd/MM/yyyy"
                                    name="fecha_emision"
                                    value={moment(dataForm.fecha_emision, 'YYYY-MM-DD').format()}
                                    onChange={(e) => handleChangeDate(e, 'fecha_emision')}
                                    renderInput={(params) => <TextField {...params} style={{ width: '100%' }} />}
                                    disabled={dataForm.reading_mode}
                                />
                            </LocalizationProvider>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={parseInt(dataForm.id_moneda) === 4 ? 2 : 3}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Moneda</InputLabel>
                            <Select
                                label="Moneda"
                                id="id_moneda"
                                name="id_moneda"
                                value={dataForm.id_moneda || ''}
                                onChange={handleChangeMoneda}
                                className='p-list-capitalize'
                                disabled={dataForm.reading_mode}
                                style={{ textTransform: 'uppercase' }}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {currencyList.map(item => (
                                    <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {parseInt(dataForm.id_moneda) === 4 &&
                        <Grid item xs={12} md={parseInt(dataForm.id_moneda) === 4 ? 2 : 0}>
                            <NumberFormat
                                style={{ width: '100%' }}
                                label="Valor tipo de cambio"
                                customInput={TextField}
                                value={dataForm?.valor_tipo_cambio}
                                thousandSeparator={local_separacion_miles}
                                decimalSeparator={local_separacion_decimales}
                                prefix={`${local_simbolo} `}
                                onValueChange={(values) => handleChangeTipoCambio(values, 'valor_tipo_cambio')}
                                decimalScale={2}
                            />
                        </Grid>
                    }

                    <Grid item xs={12} md={4}>
                        <AutocompleteContacts
                            dataForm={dataForm}
                            id_cliente={dataForm.id_cliente}
                            handleChangeCliente={handleChangeCliente}
                        />
                    </Grid>

                    {/* <Grid item xs={12} md={8}>
                        <TextField
                            label="Descripción de la factura"
                            name="referencia"
                            id="outlined-size-small"
                            value={dataForm.referencia || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese descripción de la compra'
                            onChange={handleChange}
                            disabled={dataForm.reading_mode}
                        />
                    </Grid> */}

                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Forma de pago</InputLabel>
                            <Select
                                label="Forma de pago"
                                id="id_forma_pago"
                                name="id_forma_pago"
                                value={dataForm.id_forma_pago || ''}
                                onChange={handleChange}
                                className='p-list-capitalize'
                                disabled={dataForm.reading_mode}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaFormasPagosVentas.map(item => (
                                    <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <div className="d-flex justify-content-end p-text-date">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    label="Fecha vencimiento"
                                    inputFormat="dd/MM/yyyy"
                                    name="fecha_vencimiento"
                                    value={moment(dataForm.fecha_vencimiento, 'YYYY-MM-DD').format()}
                                    onChange={(e) => handleChangeDate(e, 'fecha_vencimiento')}
                                    renderInput={(params) => <TextField {...params} style={{ width: '100%' }} />}
                                    disabled={dataForm.reading_mode}
                                />
                            </LocalizationProvider>
                        </div>
                    </Grid>

                    {dataForm.id_cliente &&
                        <Grid item xs={12} md={4}>
                            <div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: 'gray' }}>Razón social: </span>
                                <span style={{ textTransform: 'uppercase', fontSize: '13px' }}>{infoCliente.razon_social || 'sin info.'}</span>
                            </div>
                            <div>
                                <span style={{ fontWeight: 'bold', fontSize: '14px', color: 'gray' }}>RUC: </span>
                                <span style={{ textTransform: 'uppercase', fontSize: '13px' }}>{infoCliente.nro_documento || 'sin info.'}</span>
                            </div>
                            <div className="mt-2">
                                <button
                                    className="btn btn-link btn-sm p-links"
                                    onClick={handleEditContact}
                                >
                                    <i className="bi bi-pencil"></i>
                                    <span className="ms-1">Editar cliente</span>
                                </button>
                            </div>
                        </Grid>
                    }

                    {openProfileContact && (
                        <DialogProfileContact
                            open={openProfileContact}
                            setOpen={setOpenProfileContact}
                            initialState={infoCliente}
                        />
                    )}

                </Grid>
            </Grid>
        </Grid>
    );
}
